import React from 'react';
import ExpenseResolutionWorkspace from './ExpenseResolutionWorkspace';

/** 지출결의등록 */
export default function ExpenseResolutionRegister() {
  return <ExpenseResolutionWorkspace screenMode="register" />;
}
